const shouldUseV3Listings = (params?: Record<string, unknown>): boolean => {
  if (!params) return true;

  // v3 does not support date filtering
  if (params.from || params.to) return false;

  return true;
};

export default shouldUseV3Listings;
